import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {labelBeagleAbout} from "./LabelBeagleAbout";
import {labelDashboardLeftMenu} from "../DashboardMenu/LabelDashboardMenu";
import Grid from "@material-ui/core/Grid";
import plantImageLogo from './plant.jpg';


const useStyles = makeStyles({
    root: {
        maxWidth: 500,
        minWidth: 150,
    },
});

export default function BeagleAbout(props) {
    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const labelAbout = labelDashboardLeftMenu.labelAbout[langPref];

    const labelAboutNRC = labelBeagleAbout.labelAboutNRC[langPref];
    const labelAboutDryMatter = labelBeagleAbout.labelAboutDryMatter[langPref];
    const labelAboutMath = labelBeagleAbout.labelAboutMath[langPref];

    return (
        <Grid item xs={12} md={6} lg={4}>
            <Card className={classes.root}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="140"
                        image={plantImageLogo}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                            {labelAbout}
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="p" align={"left"}>
                            {labelAboutNRC}<br/><br/>
                        </Typography>
                        <Typography variant="body1" color="textPrimary" component="p" align={"left"}>
                            {labelAboutMath}<br/><br/>
                        </Typography>
                        <Typography variant="body1" color="textSecondary" component="p" align={"center"}>
                            {labelAboutDryMatter}
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>

                    <Button size="small" color="primary"
                            href="https://www.plantnutrition.io/">www.plantnutrition.io</Button>

                </CardActions>
            </Card>
        </Grid>
    );
}
